#import "./CanvasBlockBaseFields.graphql"

fragment ChartBlockFields on ChartBlock {
  ...CanvasBlockBaseFields
  chartType
  series {
    key
    color
  }
  data {
    name
    values
    formatted
  }
  xAxisLabel
  yAxisLabel
  description
}
